import { useEffect } from 'react'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'
import View from './view.js'

export default function Logic(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  useEffect(() => {
    setFlowTo(
      normalizePath(props.viewPath, '../../../CreateIteroScanRequest/Content')
    )
    setFlowTo(normalizePath(props.viewPath, '../../No'))
  }, []) // eslint-disable-line

  return <View {...props} />
}
